import axios from '../../../config/axiosConfig';
import { Admin, AdminStudent, ErrorResponse, ExportDocumentTypes, ExportFormat } from '../../../shared';
import { IStudentItemDetail, ReportRows, StudentItemDetailResponse } from './StudentItemDetail.interfaces';

export const fetchStudentItemDetail = async (admin: Admin,
  student: AdminStudent,
  fromQuiz: boolean,
  includeScoreGuides: boolean,
  includeSampleResponses: boolean,
  abortController: AbortController,
): Promise<StudentItemDetailResponse | ErrorResponse> => {
  const body = {
    adminId: admin.administrationID,
    studentId: student.testTakerName,
    IsEndOfQuiz: fromQuiz.toString(),
    includeScoreGuides,
    includeSampleResponses,
  };
  const response = await axios.post<IStudentItemDetail>(
    'api/report/studentItemDetail', body, { signal: abortController.signal }
  )
    .then((res): StudentItemDetailResponse => ({ studentItemDetail: res.data, __typename: 'StudentItemDetailResponse' }))
    .catch((errMsg): ErrorResponse => ({ __typename: 'ErrorResponse', errMsg }));
  return response;
};

export const downloadStudentItemDetailReport = async (compReport: ReportRows[], exportSignal: ExportFormat ): Promise<boolean> => {
  const body = {reports: compReport, exportFormat: exportSignal, documentType: 'StuDetail' as ExportDocumentTypes};
  const url = 'api/export/reportexport';
  try {
    const response = await axios.post<Blob>(url, body, { responseType: 'blob'});
    // Create a new Blob object using the response data of the file
    const file = new Blob([response.data], { type: response.headers['content-type'] });
    const contentDisposition = response.headers['content-disposition'] as string;

    let fileName = '';
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/gi;
    const matches = regex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
      console.log(fileName);
    }
    // Create a link to the file
    const fileURL = URL.createObjectURL(file);

    // Create a temporary anchor tag and trigger a download
    const fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();

    // Clean up by removing the link and revoking the object URL
    document.body.removeChild(fileLink);
    URL.revokeObjectURL(fileURL);
    return true;
  } catch(err) {
    console.log('Error downloading file: ', err);
    return false;
  }
};
